function InsuranceBox({children}){
    return <div style={{backgroundColor:"#EAFFFC", fontSize:"19px", padding:"10px"}}>
        {children}
    </div>
}

export default InsuranceBox;